<template>
    <div id="new-kirmizi-santral-channel-form">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>Kanal Adı</label>
                    <a-form-item
                        :validate-status="getErrorStatus('channelName')"
                        :help="getErrorMessage('channelName')"
                    >
                        <a-input
                            v-model="form.channelName"
                            placeholder="Kanal Adı"
                            name="channelName"
                            ref="channelName"
                        />
                    </a-form-item>
                </div>
                <div class="input-wrapper">
                    <label>Domain *</label>
                    <a-input
                        v-model="form.domain"
                        v-validate="'required'"
                        name="domain"
                        placeholder="Domain adresini girin"
                    />
                </div>
                <div class="input-wrapper">
                    <label>WebSocket Server *</label>
                    <a-input
                        placeholder="WebSocket server adresini girin"
                        v-model="form.websocketServer"
                        v-validate="'required'"
                        name="websocketServer"
                    />
                </div>
                <div class="input-wrapper">
                    <label>API Address *</label>
                    <a-input
                        placeholder="API adresini girin"
                        v-model="form.apiAddress"
                        v-validate="'required'"
                        name="apiAddress"
                    />
                </div>
                <div class="input-wrapper">
                    <label>Token *</label>
                    <a-input
                        placeholder="API token'ınızı girin"
                        v-model="form.token"
                        v-validate="'required'"
                        name="token"
                        type="password"
                    />
                </div>
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <a-button @click="handleCancel">İptal</a-button>
                <a-button class="pr-confirm-btn" @click="handleSubmit" type="primary" :disabled="loading">
                    Bağlan
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "CreateKirmiziSantralChannel",
    props: {
        channel: {
            type: Object,
            default: () => {},
        },
    },
    components: {},
    data() {
        return {
            form: {
                channelName: "Kırmızı Santral",
                domain: "",
                websocketServer: "",
                apiAddress: "",
                token: "",
            },
            loading: false,
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        getErrorStatus(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.form[fieldName].length < 1 && this.submitClicked ? "Bu alan zorunludur" : "";
        },
        handleCancel() {
            this.$emit("cancel");
        },
        async completeCreateChannel(payload) {
            const data = {
                payload,
                type: "webphone-kirmizisantral",
                name: this.form.channelName || "Kırmızı Santral",
            };
            return this.createChannel(data)
                .then(() => {
                    this.$message.success("Kanal başarıyla oluşturuldu");
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error("Kanal oluşturulurken bir hata oluştu");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            
            // Validate required fields
            if (!this.form.domain || !this.form.websocketServer || !this.form.apiAddress || !this.form.token) {
                this.$message.error("Tüm zorunlu alanları doldurun");
                return;
            }

            const isValid = true;
            if (isValid) {
                this.loading = true;
                const payload = {
                    domain: this.form.domain,
                    websocketServer: this.form.websocketServer,
                    apiAddress: this.form.apiAddress,
                    token: this.form.token,
                };
                this.completeCreateChannel(payload);
            }
        },
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-kirmizi-santral-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            height: 75px;

            label {
                font-weight: 500;
                margin-bottom: 5px;
            }
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style> 